import { Component, OnInit } from '@angular/core';
import { Config } from 'src/app/app-constant';
import { HttpService } from 'src/app/service/http/http.service';
import { DatePipe } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { SharedService } from 'src/app/service/shared/shared.service';
import { ColDef, ExcelExportParams, GridReadyEvent, ISetFilterParams, themeQuartz, ValueFormatterParams } from 'ag-grid-community';
import { CommentDialogComponent } from 'src/app/shared/comment-dialog/comment-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { forkJoin } from 'rxjs';
import { firstValueFrom } from 'rxjs';


@Component({
  selector: 'app-increment-logs',
  templateUrl: './increment-logs.component.html',
  styleUrls: ['./increment-logs.component.scss'],
})
export class IncrementLogsComponent  implements OnInit {
  buttonColorName:any
  selectedYear:any;
  getIncrementFyYearList:any = [];
  loggedInUserCompanyID:any;
  loggedInCompanyFiscalyear:any;
  fromYear:any;
  toYear:any;
  selectChangeType:any = "All";
  getIncrementAuditLogData:any = []

  gridData: {
    columnInfo: Array<{ label: string, propertyName: string, sortingName: string }>,
    columnData: Array<any>,
    totalCount: number,
    totalNoOfPages: number,
    showCheckBox: boolean
    showExportBtn: boolean,
    showGraphBtn: boolean
    showSearchBar: boolean,
    showAddBtn: boolean,
    currentPage: number,
    showDeleteBtn: boolean,
    tabsData: Array<any>,
    tabsMainData: Array<any>,
    showAccessConfigBtn: boolean,
    showTitle: boolean,
    showBreadCrumbs: boolean,
    showAuditLog: boolean,
    showPermantDeleteBtn: boolean,
    showRestoreBtn: boolean,
    showImportBtn: boolean,
    showBackBtn: boolean,
    showRefreshFunctinallity: boolean,
    countTabs: Array<any>,
  } = {
      columnInfo: [], columnData: [], totalCount: 0, totalNoOfPages: 0, showCheckBox: false, showExportBtn: false,
      showGraphBtn: false, showSearchBar: false, showAddBtn: false, currentPage: 0, showDeleteBtn: false,
      tabsData: [], tabsMainData: [], showAccessConfigBtn: false, showTitle: false, showBreadCrumbs: true,
      showAuditLog: true, showPermantDeleteBtn: false, showRestoreBtn: false, showImportBtn: false, showBackBtn: false,
      showRefreshFunctinallity: false, countTabs: []
    };


  constructor(private httpService: HttpService,private config: Config,private datePipe: DatePipe,public router: Router, 
    private activatedroute: ActivatedRoute,private encryptionService: EncryptionService, public dialog: MatDialog,
    public sharedService: SharedService,) { }

  ngOnInit() {
    this.subModuleButtonColor = sessionStorage.getItem('subModuleButtonColor');
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }
    this.activatedroute.params.subscribe((params: any) => {
      this.auditLogId = params?.id;
      this.auditLogModuleName = params?.moduleName;
      this.auditLogNumber = params?.code;
      // this.paginationUrl = this.config.getAllAuditLog + 'Observation' + '/' + this.observationID;
    });
    
  }

  ionViewWillEnter() {
    this.getIncrementFyYear();
  }
    
  onClickSetup() {
    this.router.navigate(['/home/hrportal/increment']);
  }

  getIncrementFyYear() {
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "fromYear": null,
      "toYear": null
    }
    this.httpService.callPostService(this.config.getOverallBudgetGrid, request).subscribe((result: any) => {
      this.getIncrementFyYearList = result.data.map((ele: any) => ({
        year: `${ele.fromYear}-${ele.toYear}`,
      }));      

      const currentYear = new Date().getFullYear();
      let yearValue = '';
      if (this.loggedInCompanyFiscalyear === 'Jan_Dec') {
        yearValue = `${currentYear}-${currentYear}`;
      } else {
        yearValue = `${currentYear}-${currentYear + 1}`;
      }

      let selectedYearIndex = this.getIncrementFyYearList.findIndex((ele: any) => ele?.year === yearValue);
      if (selectedYearIndex === -1) {
        selectedYearIndex = 0;
      }   
      this.selectedYear = this.getIncrementFyYearList[selectedYearIndex]?.year;
      var test = this.selectedYear?.split('-');
      this.fromYear = test[0];
      this.toYear = test[1];

      this.initilaizeColumn();
      if (this.selectChangeType === 'All') {
  this.getAuditLogsData(true);
} else {
  this.getAuditLogsData(false);
}

    })
  }

  onYearChange(data:any){
   if (data) {
  if (this.selectChangeType === 'All') {
    this.getAuditLogsData(true);
  } else {
    this.getAuditLogsData(false);
  }
}

  }

 onSelectChangeType(valueOrEvent: any) {
  const value = valueOrEvent?.value ?? valueOrEvent;
  const resolved = (typeof value === 'string') ? value.trim() : value;
  console.log('onSelectChangeType -> resolved value:', resolved);

  this.selectChangeType = resolved;
  // reset pagination
  this.page = 0;
  this.currentPage = 1;

  // ONLY fetchAll for "All" (and optionally Setup). Do NOT fetchAll for Increment Input.
  const fetchAll = (resolved === 'All' || resolved.toLowerCase() === 'setup');

  console.log('Calling getAuditLogsData(fetchAll=' + fetchAll + ') with type=' + this.selectChangeType);
  this.getAuditLogsData(fetchAll);
}






  isChangeDetected: boolean = false;
  currentPage: number = 1;
  auditLogId: any;
  auditLogModuleName:any;
  paginationUrl: any = '';
  showListingPage: boolean = true;
  auditLogNumber:any;
  subModuleButtonColor:any;
  page:any=0;


  initilaizeColumn() {
    this.gridData.columnInfo = [];
    this.gridData.columnInfo.push({label: 'Field', propertyName: 'fieldName',sortingName: 'columnName'});
    this.gridData.columnInfo.push({label: 'Old Value', propertyName: 'oldValue',sortingName: 'oldValue'});
    this.gridData.columnInfo.push({label: 'New Value', propertyName: 'newValue',sortingName: 'newValue'});
    this.gridData.columnInfo.push({label: 'Changed By', propertyName: 'lastModifiedBy',sortingName: 'lastModifiedBy'});
    this.gridData.columnInfo.push({label: 'Changed On', propertyName: 'updatedAt',sortingName: 'updatedAt'});
    this.buildColumnDefs();
  }
  /**
 * Fetch audit logs.
 * If fetchAll === true => fetch all server pages and combine results.
 * If fetchAll === false => fetch only the current page (fast).
 */

getAuditLogsData(fetchAll: boolean = false) {
  const normalizeStr = (s: any) =>
    String(s ?? '').replace(/[_\s-]+/g, ' ').trim().toLowerCase();

  if (!this.selectedYear) {
    console.warn('selectedYear not set — aborting getAuditLogsData');
    return;
  }

  // Resolve mapped type (supports both string and {apiType, variants})
  const mappedTypeRaw: any = this.getApiTypeFromUi ? this.getApiTypeFromUi(this.selectChangeType) : this.selectChangeType;
  const mappedTypeString: string = mappedTypeRaw && typeof mappedTypeRaw === 'object' && 'apiType' in mappedTypeRaw
    ? String((mappedTypeRaw as any).apiType)
    : String(mappedTypeRaw);

  // Build normalized variants (ONLY include increment extras when this type is increment)
  let mappedVariants: string[] = [];
  if (mappedTypeRaw && typeof mappedTypeRaw === 'object' && Array.isArray((mappedTypeRaw as any).variants)) {
    mappedVariants = (mappedTypeRaw.variants as string[]).map(v => normalizeStr(v));
  } else {
    mappedVariants = [normalizeStr(mappedTypeString), normalizeStr(this.selectChangeType)];
  }

  // Only add extra 'increment' variants when mapped/ui type is increment input
  const isMappedOrUiIncrement = normalizeStr(mappedTypeString) === 'increment input' || normalizeStr(this.selectChangeType) === 'increment input';
  if (isMappedOrUiIncrement) {
    const extraIncrementVariants = ['increment input', 'increment_input', 'incrementinput', 'increment-input'];
    mappedVariants = Array.from(new Set([...mappedVariants, ...extraIncrementVariants.map(v => normalizeStr(v))]));
  } else {
    mappedVariants = Array.from(new Set(mappedVariants)); // dedupe but do not add increment extras
  }

  // Helper to fetch all pages for a given type (returns combined logs)
  const fetchAllPagesForType = async (typeStr: string) => {
    const request = { companyId: this.loggedInUserCompanyID, type: typeStr, year: this.selectedYear };
    const baseUrl = `${this.config.getIncrementAuditLog}`;
    const firstPageUrl = `${baseUrl}?page=0&sort=${this.sortName},${this.sortBy}`;
    try {
      const eventOrRes: any = await firstValueFrom(this.httpService.callPostService(firstPageUrl, request));
      const res: any = eventOrRes && eventOrRes.body ? eventOrRes.body : eventOrRes;
      const firstLogs = (res?.data?.logs as any[]) || [];
      const totalPages = res?.data?.totalPages ?? 0;

      if (totalPages <= 1) {
        return firstLogs;
      }

      const requests = [];
      for (let p = 1; p < totalPages; p++) {
        const url = `${baseUrl}?page=${p}&sort=${this.sortName},${this.sortBy}`;
        requests.push(this.httpService.callPostService(url, request));
      }

      const responses: any[] = await firstValueFrom(forkJoin(requests));
      let allLogs = [...firstLogs];
      for (const r of responses) {
        const pageRes: any = r && r.body ? r.body : r;
        allLogs = allLogs.concat(pageRes?.data?.logs ?? []);
      }
      return allLogs;
    } catch (err) {
      console.error('fetchAllPagesForType failed for type', typeStr, err);
      return [];
    }
  };

  // Special-case Attition: compute Increment Input as All - Setup (so you get 31)
  const isAttitionCompany = Number(this.loggedInUserCompanyID) === 266;
  if (isAttitionCompany && normalizeStr(mappedTypeString) === 'increment input') {
    (async () => {
      console.log('Attition special case: computing Increment Input as All - Setup (fetching both fully)...');
      const [allLogs, setupLogs] = await Promise.all([
        fetchAllPagesForType('All'),
        fetchAllPagesForType('SETUP')
      ]);

      const setupIds = new Set<string|number>();
      const setupColNames = new Set<string>();
      for (const s of setupLogs || []) {
        if (s && ('id' in s) && s.id != null) setupIds.add(s.id);
        if (s && s.columnName) setupColNames.add(String(s.columnName).trim());
      }

      const filtered = (allLogs || []).filter((a: any) => {
        if (a && ('id' in a) && a.id != null) {
          return !setupIds.has(a.id);
        }
        const name = a?.columnName ? String(a.columnName).trim() : '';
        return !setupColNames.has(name);
      });

      console.log('Attition computed: allLogs:', (allLogs||[]).length, ' setupLogs:', (setupLogs||[]).length, ' final (All - Setup):', filtered.length);

      this.gridData.totalNoOfPages = 1;
      this.gridData.totalCount = filtered.length;
      this.gridData.currentPage = 1;
      this.renderColumnData(filtered);
      this.buildColumnDefs?.();
      this.updateAgGrid(true);
    })();
    return;
  }

  // Default flow: ask server for the mapped type
  const request = {
    companyId: this.loggedInUserCompanyID,
    type: mappedTypeString,
    year: this.selectedYear
  };
  const firstPageUrl = `${this.config.getIncrementAuditLog}?page=${this.page}&sort=${this.sortName},${this.sortBy}`;
  console.log('POST ->', firstPageUrl, ' payload ->', request);
  console.log('Mapped variants (normalized):', mappedVariants);

  this.httpService.callPostService(firstPageUrl, request).subscribe(
    (eventOrRes: any) => {
      const apiRes: any = eventOrRes && eventOrRes.body ? eventOrRes.body : eventOrRes;
      console.log('audit API raw response (page ' + this.page + '):', apiRes);

      const firstLogs = (apiRes?.data?.logs as any[]) || [];
      const totalPages = apiRes?.data?.totalPages ?? 0;
      const serverTotal = apiRes?.data?.total ?? 0;

      const uniqColumnNames = Array.from(new Set((firstLogs || []).map((r: any) => r?.columnName ?? '<<no-columnName>>')));
      console.log('Unique columnName values in server response (page ' + this.page + '):', uniqColumnNames);

      // If user selected increment & server actually returned increment-like names, we may filter.
      // Otherwise do not filter for All/Setup/etc.
      const isIncrementUiSelected = normalizeStr(this.selectChangeType) === 'increment input';
      const isMappedTypeIncrementNow = mappedVariants.includes('increment input') || mappedVariants.includes('increment_input') || mappedVariants.includes('incrementinput');
      const isIncrementSelected = isIncrementUiSelected || isMappedTypeIncrementNow;
      const uniqNorm = uniqColumnNames.map(n => normalizeStr(n));
      const serverHasIncrementVariant = uniqNorm.some(n => mappedVariants.includes(n) || n === 'increment input');
      const shouldApplyStrictFilter = isIncrementSelected && serverHasIncrementVariant;

      if (isIncrementSelected && !serverHasIncrementVariant) {
        console.log('Increment Input selected but server did NOT return increment-like columnNames; skipping strict filter and using fallback substring match.');
      }

      const applyIncrementInputFilter = (logs: any[]) => {
        if (!isIncrementSelected) return logs; // do not filter when user hasn't selected Increment Input

        if (shouldApplyStrictFilter) {
          const filtered = (logs || []).filter((r: any) => {
            const colNorm = normalizeStr(r?.columnName);
            return mappedVariants.includes(colNorm) || colNorm === 'increment input';
          });
          console.log('Client-side strict filter applied for Increment Input -> serverTotal:', serverTotal, ' filteredCount:', filtered.length);
          return filtered;
        }

        // fallback substring match
        const fallbackFiltered = (logs || []).filter((r: any) => {
          const col = String(r?.columnName ?? '').toLowerCase();
          return col.includes('increment');
        });
        console.log('Client-side fallback substring filter applied (contains "increment") -> serverTotal:', serverTotal, ' filteredCount:', fallbackFiltered.length);
        return (fallbackFiltered.length > 0) ? fallbackFiltered : logs;
      };

      // Pagination / fetch-all logic (unchanged; use applyIncrementInputFilter where rendering)
      if (fetchAll && totalPages > 1) {
        const requests = [];
        for (let p = 0; p < totalPages; p++) {
          if (p === Number(this.page)) continue;
          const url = `${this.config.getIncrementAuditLog}?page=${p}&sort=${this.sortName},${this.sortBy}`;
          requests.push(this.httpService.callPostService(url, request));
        }

        if (requests.length === 0) {
          const toRender = applyIncrementInputFilter(firstLogs);
          this.gridData.totalNoOfPages = totalPages;
          this.gridData.totalCount = isIncrementSelected ? toRender.length : serverTotal;
          this.gridData.currentPage = apiRes?.data?.currentPageNumber ?? 1;
          this.renderColumnData(toRender);
          this.buildColumnDefs?.();
          this.updateAgGrid(true);
          return;
        }

        forkJoin(requests).subscribe(
          (responses: any[]) => {
            let allLogs = [...firstLogs];
            for (const r of responses) {
              const pageRes: any = r && r.body ? r.body : r;
              allLogs = allLogs.concat(pageRes?.data?.logs ?? []);
            }
            const finalLogs = applyIncrementInputFilter(allLogs);
            this.gridData.totalNoOfPages = totalPages;
            this.gridData.totalCount = isIncrementSelected ? finalLogs.length : serverTotal;
            this.gridData.currentPage = 1;
            this.renderColumnData(finalLogs);
            this.buildColumnDefs?.();
            this.updateAgGrid(true);
          },
          (err) => {
            console.error('Error fetching additional pages:', err);
            const toRender = applyIncrementInputFilter(firstLogs);
            this.gridData.totalNoOfPages = totalPages;
            this.gridData.totalCount = isIncrementSelected ? toRender.length : serverTotal;
            this.gridData.currentPage = apiRes?.data?.currentPageNumber ?? 1;
            this.renderColumnData(toRender);
            this.buildColumnDefs?.();
            this.updateAgGrid(true);
          }
        );

        return;
      }

      if (!fetchAll && serverTotal > (firstLogs?.length ?? 0)) {
        const pagesToUse = totalPages > 0 ? totalPages : Math.ceil(serverTotal / (firstLogs.length || serverTotal));
        const remainingPages: number[] = [];
        for (let p = 0; p < pagesToUse; p++) {
          if (p === Number(this.page)) continue;
          remainingPages.push(p);
        }

        if (remainingPages.length === 0) {
          const toRender = applyIncrementInputFilter(firstLogs);
          this.gridData.totalNoOfPages = totalPages;
          this.gridData.totalCount = isIncrementSelected ? toRender.length : serverTotal;
          this.gridData.currentPage = apiRes?.data?.currentPageNumber ?? 1;
          this.renderColumnData(toRender);
          this.buildColumnDefs?.();
          this.updateAgGrid(true);
          return;
        }

        const reqs = remainingPages.map(p => {
          const url = `${this.config.getIncrementAuditLog}?page=${p}&sort=${this.sortName},${this.sortBy}`;
          return this.httpService.callPostService(url, request);
        });

        forkJoin(reqs).subscribe(
          (responses: any[]) => {
            let allLogs = [...firstLogs];
            for (const r of responses) {
              const pageRes: any = r && r.body ? r.body : r;
              allLogs = allLogs.concat(pageRes?.data?.logs ?? []);
            }
            let finalLogs = applyIncrementInputFilter(allLogs);
            if (!isIncrementSelected && finalLogs.length > serverTotal) finalLogs = finalLogs.slice(0, serverTotal);
            this.gridData.totalNoOfPages = totalPages;
            this.gridData.totalCount = isIncrementSelected ? finalLogs.length : serverTotal;
            this.gridData.currentPage = 1;
            this.renderColumnData(finalLogs);
            this.buildColumnDefs?.();
            this.updateAgGrid(true);
          },
          (err) => {
            console.error('Error fetching remaining pages:', err);
            const toRender = applyIncrementInputFilter(firstLogs);
            this.gridData.totalNoOfPages = totalPages;
            this.gridData.totalCount = isIncrementSelected ? toRender.length : serverTotal;
            this.gridData.currentPage = apiRes?.data?.currentPageNumber ?? 1;
            this.renderColumnData(toRender);
            this.buildColumnDefs?.();
            this.updateAgGrid(true);
          }
        );

        return;
      }

      const toRender = applyIncrementInputFilter(firstLogs);
      this.gridData.totalNoOfPages = totalPages;
      this.gridData.totalCount = isIncrementSelected ? toRender.length : serverTotal;
      this.gridData.currentPage = apiRes?.data?.currentPageNumber ?? 1;
      this.renderColumnData(toRender);
      this.buildColumnDefs?.();
      this.updateAgGrid(true);
      console.log('Rendered rows (single page):', this.gridData.columnData.length);
    },
    (error: any) => {
      console.error('Error fetching audit logs:', error);
      try { if (error && error.error) console.error('Server error body:', error.error); } catch(e) {}
    }
  );
}







// --- Optional quick-test helper: run once in dev to discover the right 'type' values ---
// Call this from ngOnInit or console to test candidate type strings (remove after use)
quickTypeProbe() {
  const testTypes = [
    'INCREMENT_INPUT','increment_input','Increment Input','increment-input',
    'incrementinput','INCREMENTINPUT','INCREMENT_SETUP','Increment Setup','INCREMENT SETUP'
  ];

  const firstPageUrl = this.config.getIncrementAuditLog + '?page=0';

  testTypes.forEach(t => {
    const req = { companyId: this.loggedInUserCompanyID, type: t, year: this.selectedYear };

    this.httpService.callPostService(firstPageUrl, req).subscribe(
      (eventOrRes: any) => {
        // handle both HttpEvent (with .body) and plain body
        const res: any = eventOrRes && eventOrRes.body ? eventOrRes.body : eventOrRes;

        // defensive: if no shape we expect, log what's returned
        if (!res || (!res.data && !res.total && !res.logs)) {
          console.log(`Probe type: ${t} -> unexpected response shape:`, res);
          return;
        }

        // prefer res.data if present (your API shape), otherwise try fallback properties
        const total = res?.data?.total ?? res?.total ?? 0;
        const logs = res?.data?.logs ?? res?.logs ?? [];

        console.log(`Probe type: ${t} -> total: ${total} | sample columnNames:`, (logs || []).slice(0, 10).map((x: any) => x.columnName));
      },
      (err: any) => {
        // print useful error info
        console.warn(`Probe type failed: ${t}`, err);
        try {
          if (err && err.error) console.warn('Server error body:', err.error);
        } catch (e) { /* ignore */ }
      }
    );
  });
}








  renderColumnData(logData: any) {
  this.gridData.columnData = [];
  if (!Array.isArray(logData)) logData = [];

  for (let i = 0; i < logData.length; i++) {
    const row = {
      id: logData[i].id,
      fieldName: logData[i]?.columnName,
      oldValue: logData[i]?.oldValue,
      newValue: logData[i]?.newValue,
      lastModifiedBy: (logData[i]?.firstName ?? '') + ' ' + (logData[i]?.lastName ?? ''),
      updatedAt: this.datePipe.transform(logData[i]?.updatedAt, "dd MMM yyyy | hh:mm a"),
    };
    this.gridData.columnData.push(row);
  }

  this.isChangeDetected = !this.isChangeDetected;
  this.mapRenderData();
  console.log('renderColumnData completed. gridData.columnData.length =', this.gridData.columnData.length);
}

  renderData:any = [];
  mapRenderData() {
    this.renderData = [];
    for (let i = 0; i < this.gridData.columnData.length; i++) {
      var output = Object.entries(this.gridData.columnData[i]).map(([key, value]) => ({ key, value }));
      this.renderData.push(output);
    }
  }
  sortName:any='updatedAt';
  sortBy:any='desc'
  sortAsending(name:any){
    this.sortName=name;
    this.sortBy = 'asc';
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "type": this.selectChangeType,
      "year": this.selectedYear
    }
    this.httpService.callPostService(this.config.getIncrementAuditLog + '?page=' + this.page+'&sort=' + this.sortName + ','+this.sortBy ,request).subscribe((res:any)=>{
      this.gridData.totalNoOfPages = res?.data?.totalPages;
      this.gridData.totalCount = res?.data?.total;
      this.gridData.currentPage = res?.data?.currentPageNumber;
      this.renderColumnData(res.data?.logs);
    },(error:any)=>{
      console.log(error)
    })
  }
  sortDesending(name:any){
    this.sortName = name;
    this.sortBy = 'desc';
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "type": this.selectChangeType,
      "year": this.selectedYear
    }
    this.httpService.callPostService(this.config.getIncrementAuditLog + '?page=' + this.page+'&sort=' + this.sortName + ','+this.sortBy ,request).subscribe((res:any)=>{
      this.gridData.totalNoOfPages = res?.data?.totalPages;
      this.gridData.totalCount = res?.data?.total;
      this.gridData.currentPage = res?.data?.currentPageNumber;
      this.renderColumnData(res.data?.logs);
    },(error:any)=>{
      console.log(error)
    })
  }
  pageChange(response:any){
    this.currentPage = response.currentPageNumber - 1;
    this.renderColumnData(response.data.plant);
  }
  backbtn(){
    this.router.navigate(['/home/hrportal/employeemaster', { id: this.auditLogId, operation: 'Show' }]);
  }
  backbtnToListingpage(){
    this.router.navigate(['/home/hrportal/employeemaster']);
  }
  previousPage(){
    if(this.currentPage < 2){
      return;
    }else{
      this.currentPage--;
      this.page--;
      this.getAuditLogsData();
    }
  }
  nextPage(){
    if(this.currentPage >= this.gridData.totalNoOfPages){
      return;
    }
    if(this.currentPage==1){
      this.page=1;
    }else{
      this.page++;
    }
    this.currentPage++;
    this.getAuditLogsData();
  }

  // --------------------------------AG GRID CODE---------------------------------------------------------
  gridApi: any = null;
  gridColumnApi: any = null;
  paginationPageSizeSelector = [5, 10, 20, 50, 100, 200, 500, 1000];
  pagination = true;
  paginationPageSize = 10;
  detailRowAutoHeight = true;

  defaultColDef: ColDef = {
    flex: 1,
    minWidth: 100,
    filter: true,
    resizable: true,
    sortable: true,
    floatingFilter: false,  // ✅ small filter box under header
  };

  gridOptions: any = {
    defaultColDef: {
      resizable: true,
      sortable: true,
      filter: true,
      floatingFilter: true,
      minWidth: 80,

      // ✅ add this
      cellClass: (p: any) => (p.node.rowIndex % 2 === 0 ? 'cell-even' : 'cell-odd')
    },
    context: { componentParent: this },
    rowSelection: 'single',
    localeText: {
      noRowsToShow: 'No Data Found'  // default text ko replace karna hai 'No Rows To Show' to 'No Data Found'
    }
  };

  openCommentModal(text: string, commentType: any) {
    this.dialog.open(CommentDialogComponent, {
      width: '600px',
      data: {
        text: text,
        commentType: commentType
      }
    });

  }
  pendingGridUpdate: boolean = false;

  onGridReady(params: any) {
  // use any to avoid strict typing mismatch
  this.gridApi = params.api;
  this.gridColumnApi = params.columnApi ?? (params as any).columnApi;

  try { this.gridApi.sizeColumnsToFit(); } catch (e) { /* ignore if method not available yet */ }
  console.log('ag-grid ready:', params);

  if (this.pendingGridUpdate) {
    this.pendingGridUpdate = false;
    this.buildColumnDefs?.();
    this.updateAgGrid();
  }
}
  formatStatus(value: any): string {
    if (!value || typeof value !== 'string') {
      return 'N/A'; // fallback agar value string na ho
    }

    // Camel Case → Title Case
    return value
      .toLowerCase()
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

  formatDate(value: any): string {
    if (!value) return 'N/A';

    const date = new Date(value);
    if (isNaN(date.getTime())) return 'Invalid Date';

    // dd-MM-yyyy format
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  }


  // Helper function to convert any date string into dd-MM-yyyy
  formatDateOnly(dateStr: string | null): string | null {
    if (!dateStr) return null;

    let datePart = dateStr;
    if (dateStr.includes('T')) {
      datePart = dateStr.split('T')[0];
    }

    const [y, m, d] = datePart.split('-').map(Number);
    if (!y || !m || !d) return null;

    // Date object 
    const date = new Date(y, m - 1, d);

    // Format dd-MM-yyyy
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  }

  // ✅ Global search function
  onFilterTextBoxChanged(value: string = '') {
    if (!this.gridApi) return;

    // v31+ way:
    this.gridApi.setGridOption('quickFilterText', value ?? '');

  }

onBtExport() {
  if (!this.gridApi) {
    console.warn('Grid API not ready; cannot export.');
    return;
  }

  try {
    // get displayed row count (safe fallback to 0)
    const displayedCount = typeof this.gridApi.getDisplayedRowCount === 'function'
      ? Number(this.gridApi.getDisplayedRowCount())
      : 0;

    // defaults
    let startIndex = 0;
    let endIndexExclusive: number = displayedCount; // ALWAYS a number (never null)

    // if pagination is enabled and grid supports pagination API, calculate page window
    const hasPaginationApi = typeof this.gridApi.paginationGetCurrentPage === 'function'
                         && typeof this.gridApi.paginationGetPageSize === 'function';

    if (this.pagination && hasPaginationApi) {
      const currentPage = Number(this.gridApi.paginationGetCurrentPage()); // 0-based
      const pageSize = Number(this.gridApi.paginationGetPageSize());

      if (Number.isFinite(currentPage) && Number.isFinite(pageSize) && pageSize > 0) {
        startIndex = Math.max(0, currentPage * pageSize);
        endIndexExclusive = startIndex + pageSize;
      }
    }

    // Clamp to safe bounds
    if (!Number.isFinite(startIndex) || startIndex < 0) startIndex = 0;
    if (!Number.isFinite(endIndexExclusive) || endIndexExclusive < 0) endIndexExclusive = displayedCount;
    if (endIndexExclusive > displayedCount) endIndexExclusive = displayedCount;

    if (endIndexExclusive <= startIndex) {
      console.warn('No rows in current page to export.');
      return;
    }

    const params: ExcelExportParams = {
      fileName: 'Increment_Log_' + new Date().toISOString().slice(0, 10) + '.xlsx',
      sheetName: 'IncrementLog',
      exportAsExcelTable: {
        showRowStripes: true,
        name: 'IncrementTable'
      },

      processCellCallback: (cell: any) => {
        const header = cell.column.getColDef().headerName;
        const value = cell.value;

        const dateColumns = ['date', 'dateOfExpense']; // adjust if needed

        if (dateColumns.includes(cell.column.getColId()) && cell.value) {
          const date = new Date(cell.value);
          if (!isNaN(date.getTime())) {
            return (
              ('0' + date.getDate()).slice(-2) +
              '-' +
              ('0' + (date.getMonth() + 1)).slice(-2) +
              '-' +
              date.getFullYear()
            );
          }
        }

        if (header === 'Status' && value) {
          return value
            .toString()
            .toLowerCase()
            .replace(/_/g, ' ')
            .replace(/\b\w/g, (char: any) => char.toUpperCase());
        }

        return value;
      },

      shouldRowBeSkipped: (paramsRow: any) => {
        const node = paramsRow && paramsRow.node;
        if (!node || typeof node.rowIndex !== 'number') {
          // If index can't be determined, skip row to be safe
          return true;
        }
        const idx = node.rowIndex;
        return idx < startIndex || idx >= endIndexExclusive;
      }
    };

    this.gridApi.exportDataAsExcel(params);
  } catch (err) {
    console.error('Export (page) failed:', err);
  }
}

 

  approvalRenderer(params: any) {
    if (!params.value) return '';
    const status = params.value.toUpperCase();

    let color = '';
    if (status === 'APPROVED') {
      color = '#4caf50'; // green
    } else if (status === 'REJECTED') {
      color = '#f44336'; // red
    } else if (status === 'PENDING') {
      color = '#ff9800'; // orange
    }

    return `
          <span style="
            border: 1px solid ${color};
            color: ${color};
            padding: 4px 10px;
            border-radius: 12px;
            font-size: 12px;
            font-weight: 500;
            display: inline-block;
            line-height: 20px;
            white-space: nowrap;
          ">
        ${status.charAt(0) + status.slice(1).toLowerCase()}
      </span>
    `;
  }

  statusFormatter(params: any): string {
    if (!params.value) return '';

    const valueUpper = params.value.toUpperCase();

    // 🔹 Status → Color map
    const statusColors: Record<string, string> = {
      'APPROVED_BY_FINANCE_BUT_NOT_PAID': '#4caf50', // green
      'APPROVED_BY_MANAGER_SENT_TO_FINANCE': '#4caf50',
      'APPROVED_BY_MANAGER_REJECTED_BY_FINANCE': '#f44336', // red
      'REJECTED_BY_MANAGER': '#f44336',
      'PENDING_WITH_MANAGER': '#ff9800' // orange
    };

    // 🔹 Default color = grey
    const color =
      Object.keys(statusColors).find(key => valueUpper.includes(key))
        ? statusColors[
        Object.keys(statusColors).find(key => valueUpper.includes(key))!
        ]
        : '#999';

    // 🔹 Convert to Title Case
    const formattedText = params.value
      .toLowerCase()
      .split('_')
      .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');

    return `
      <span style="
        border: 1px solid ${color};
        color: ${color};
        padding: 4px 10px;
        border-radius: 12px;
        font-size: 12px;
        font-weight: 500;
        display: inline-block;
        white-space: normal;
        word-wrap: break-word;
        line-height: 1.4em;
        animation: fadeInScale 0.3s ease-in-out;
        max-width: 100%;
      ">
        ${formattedText}
      </span>
    `;
  }

  dateRenderer(params: any) {
    if (!params.value) return '';
    const date = new Date(params.value);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }

  dateComparator(valueA: string, valueB: string) {
    const parseDate = (value: string) => {
      if (!value) return null;
      // Agar backend se yyyy-mm-dd aa raha hai:
      if (value.includes('-') && value.indexOf('-') === 4) {
        return new Date(value).getTime();
      }
      // Agar already dd-mm-yyyy format hai:
      const [day, month, year] = value.split('-').map(Number);
      return new Date(year, month - 1, day).getTime();
    };

    const dateA = parseDate(valueA);
    const dateB = parseDate(valueB);

    if (dateA === dateB) return 0;
    if (dateA == null) return -1;
    if (dateB == null) return 1;
    return dateA - dateB;
  }

  openFile(fileUrl: string) {
    window.open(fileUrl, '_blank');
  }
  downloadRenderer = (params: any) => {

    const fileUrl = `${this.config.downloadFile}${params.value}`;
    if (!params.value) return '';
    const img = document.createElement('img');
    img.src = 'assets/icon/yellowdownload.png'; // replace with your icon path
    img.alt = 'download';
    img.style.width = '18px';
    img.style.height = '18px';
    img.style.cursor = 'pointer';
    img.title = params.value;
    img.addEventListener('click', (e) => {
      e.stopPropagation();
      // open file in new tab
      window.open(fileUrl, '_blank');
    });
    return img;
  }

  downloadDialogRenderer(fileName: string): string {
    if (!fileName) return '';
    return `${this.config.downloadFile}${fileName}`;
  }
  selectedRow: any;
  isDetailsOpen = false;
  onRowClicked(event: any) {
    this.selectedRow = event.data;
    this.isDetailsOpen = true;
  }
  closeDetails() {
    this.isDetailsOpen = false;
  }
  searchTaskString: string = '';

  isClicked = false;


  resetGrid() {
    this.isClicked = false; // Trigger animation

    if (this.gridApi) {
      // ✅ Reset filters & sorting
      this.gridApi.setFilterModel(null);
      // this.gridApi.setSortModel(null);
      this.gridApi.deselectAll();

      // ✅ Reset quick filter (search box)
      this.searchTaskString = '';
      this.gridApi.setGridOption('quickFilterText', ''); // Clears quick filter text

      // ✅ Reset pagination
      this.paginationPageSize = 10;
      this.gridApi.setGridOption('paginationPageSize', this.paginationPageSize);
      this.gridApi.paginationGoToFirstPage();

      // ✅ Force refresh so UI input also clears
      this.gridApi.refreshCells();
      this.gridApi.resetColumnState();         // ✅ Reset columns
    }
  }
  columnDefs: any[] = [];
  buildColumnDefs() {
  this.columnDefs = this.gridData.columnInfo.map(col => {
    return {
      headerName: col.label,
      field: col.propertyName,
      sortable: true,
      suppressMenu: true,

      cellRenderer: (params: any) => {
        const value = params.value;

        // hide ID column just like your HTML
        if (col.propertyName === 'id') {
          return '';
        }

        // Contract link logic (same as your <a> in HTML)
        if (
          (col.propertyName === 'oldValue' || col.propertyName === 'newValue') &&
          typeof value === "string" &&
          value.includes('uploadingTheContract')
        ) {
          return `<a href="${value}" target="_blank" rel="noopener noreferrer">Contract</a>`;
        }

        return value ?? '';
      }
    };
  });
}
// inside IncrementLogsComponent class
// inside IncrementLogsComponent class
getApiTypeFromUi(uiValue: string): { apiType: string, variants: string[] } | string {
  const v = (uiValue ?? '').toString().trim();
  if (!v) return { apiType: v, variants: [v] };

  // canonical mapping (what you send to server)
  if (v.toLowerCase() === 'all') return { apiType: 'All', variants: ['All'] };
  if (v.toLowerCase() === 'setup') return { apiType: 'SETUP', variants: ['SETUP', 'Setup', 'setup'] };

  // common forms for increment input
  if (v.replace(/\s+/g,' ').toLowerCase() === 'increment input') {
    const variants = [
      'INCREMENT_INPUT', 'increment_input', 'Increment Input', 'increment input',
      'increment-input', 'incrementinput', 'INCREMENTINPUT', 'INCREMENT INPUT', 'IncrementInput'
    ];
    return { apiType: 'INCREMENT_INPUT', variants };
  }

  // fallback: return object with some normalized variants
  const normalized = v.replace(/[_\s-]+/g, ' ').trim();
  return { apiType: v, variants: [v, normalized, normalized.toLowerCase()] };
}


updateAgGrid(forceClear: boolean = false) {
  console.log('updateAgGrid called. gridApi ready?', !!this.gridApi,
              'colDefs:', this.columnDefs?.length ?? 0,
              'rows (component):', this.gridData?.columnData?.length ?? 0,
              'forceClear:', forceClear);

  if (!this.gridApi) {
    this.pendingGridUpdate = true;
    console.warn('AG Grid API not ready — update scheduled.');
    return;
  }

  try {
    // 1) Clear grid immediately if requested
    if (forceClear && typeof this.gridApi.setRowData === 'function') {
      try {
        this.gridApi.setRowData([]);            // clear rows
        this.gridApi.deselectAll();            // clear selection
        // small delay can help if grid was mid-update; use microtask
      } catch (e) {
        console.warn('clear setRowData/deselectAll failed', e);
      }
    }

    // 2) Reset pagination page size to your default BEFORE loading new data (if supported)
    try {
      if (this.pagination && typeof this.gridApi.paginationSetPageSize === 'function') {
        console.log('Attempting to reset pagination page size to', this.paginationPageSize);
        this.gridApi.paginationSetPageSize(this.paginationPageSize);
      } else {
        console.log('paginationSetPageSize not available or pagination disabled');
      }
    } catch (e) {
      console.warn('paginationSetPageSize failed', e);
    }

    // 3) Set column defs (safe)
    if (this.columnDefs && Array.isArray(this.columnDefs) && typeof this.gridApi.setColumnDefs === 'function') {
      try { this.gridApi.setColumnDefs(this.columnDefs); } catch (e) { console.warn('setColumnDefs failed', e); }
    }

    // 4) Now load authoritative rowData
    if (this.gridData && Array.isArray(this.gridData.columnData) && typeof this.gridApi.setRowData === 'function') {
      try {
        this.gridApi.setRowData(this.gridData.columnData);
      } catch (e) {
        console.warn('setRowData failed', e);
      }
    }

    // 5) Ensure we're on first page (if pagination supported)
    try {
      if (this.pagination && typeof this.gridApi.paginationGoToPage === 'function') {
        try { this.gridApi.paginationGoToPage(0); } catch (e) { console.warn('paginationGoToPage failed', e); }
      }
    } catch (e) {
      console.warn('paginationGoToPage wrapper failed', e);
    }

    // 6) Force a client-side row model refresh so internal indexes update
    try {
      // 'filter' or 'aggregate' are valid steps; refreshClientSideRowModel without args also works in many versions
      if (typeof (this.gridApi as any).refreshClientSideRowModel === 'function') {
        (this.gridApi as any).refreshClientSideRowModel('filter'); // keeps filters but rebuilds rowsToDisplay
      } else if (typeof this.gridApi.refreshClientSideRowModel === 'function') {
        (this.gridApi as any).refreshClientSideRowModel();
      } else {
        // fallback: refresh cells / redraw rows
        if (typeof this.gridApi.refreshCells === 'function') this.gridApi.refreshCells();
        if (typeof this.gridApi.redrawRows === 'function') this.gridApi.redrawRows();
      }
    } catch (e) {
      console.warn('refreshClientSideRowModel/refreshCells failed', e);
    }

    // 7) Size columns
    try { if (typeof this.gridApi.sizeColumnsToFit === 'function') this.gridApi.sizeColumnsToFit(); } catch (e) {}

    // 8) Log detailed pagination internals for debugging
    try {
      const pageSize = typeof this.gridApi.paginationGetPageSize === 'function' ? this.gridApi.paginationGetPageSize() : 'n/a';
      const currentPage = typeof this.gridApi.paginationGetCurrentPage === 'function' ? this.gridApi.paginationGetCurrentPage() : 'n/a';
      const totalPages = typeof this.gridApi.paginationGetTotalPages === 'function' ? this.gridApi.paginationGetTotalPages() : 'n/a';
      const displayed = typeof this.gridApi.getDisplayedRowCount === 'function' ? this.gridApi.getDisplayedRowCount() : 'n/a';
      console.log('AG Grid internals -> pageSize:', pageSize, ' currentPage:', currentPage, ' totalPages:', totalPages, ' displayedRows:', displayed);
    } catch (e) {
      console.warn('pagination introspection failed', e);
    }

  } catch (outerErr) {
    console.error('updateAgGrid unexpected error', outerErr);
  }
}





  // --------------------------------AG GRID CODE---------------------------------------------------------



}
